import { render, staticRenderFns } from "./TqList.vue?vue&type=template&id=36d21532&scoped=true&"
import script from "./TqList.vue?vue&type=script&lang=js&"
export * from "./TqList.vue?vue&type=script&lang=js&"
import style0 from "./TqList.vue?vue&type=style&index=0&id=36d21532&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d21532",
  null
  
)

export default component.exports